export default __webpack_public_path__ + "static/media/admin_product_profile_icon.740a9c51.svg";